import React, { Component } from "react";
import { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";
import store from "../../store";

import primaryTheme from "../../theme/primaryTheme";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

// component
import Layout from "../../components/Layout/Layout";
import Routes from "../../routes/routes";

// test database connection
import "../../firebase/firebase";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";

const THEME = createMuiTheme({
  typography: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "1.7",
  },
});

class App extends Component {
  state = {
    theme: primaryTheme,
    showSideDrawer: true,
  };

  render() {
    console.log(this.state);
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={THEME}>
          <ThemeProvider theme={this.state.theme}>
            <Layout>
              <ScrollToTop>
                <Routes />
              </ScrollToTop>
            </Layout>
          </ThemeProvider>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/App.js